
<div class="modal">

  <!-- Header -->
  <div class="modal-header" style="display: none;">
    <div class="header-left">
      <div class="header-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
          <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
        </svg>
      </div>
      <div class="header-text">
        <h2>Add Component</h2>
        <p>Associate a new component to this truck</p>
      </div>
    </div>
    <button class="close-btn">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
        <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
  </div>

  <!-- Truck Banner -->
  <div class="truck-banner">
    <div class="truck-left">
      <div class="truck-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7V8z"/>
          <circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
        </svg>
      </div>
      <div>
        <div class="truck-id">{{truckDetails?.truckNumber}}</div>
        <div class="truck-sub">{{truckDetails?.truckModel}} · 32 FT MXL2</div>
      </div>
    </div>
    <div class="truck-right">
      <div class="km-badge"><span>Current KM: </span>{{truckDetails?.initialKmTravelled}}</div>
      <div class="live-badge"><div class="live-dot"></div> 5 Live</div>
    </div>
  </div>

  <div class="modal-body">

    <!-- Step 1 -->
    <div class="step-label">Step 1 — Component Type &amp; Serial</div>
    <div class="form-row">
      <div class="form-group">
        <label><span class="req">*</span> Component Type</label>
        <div class="select-wrap">
            <ng-select (change)="onTypeChange($event)" appendTo="body"  placeholder="Select " class="field-input filled">
                <ng-option value="Tyre">Tyre</ng-option>
                <ng-option value="Battery">Battery</ng-option>
            </ng-select>
        </div>
        <span class="form-hint">Tyre, Battery, Insurance, PUC, R&amp;M</span>
      </div>
      <div class="form-group" *ngIf="componentType == 'Tyre'">
        <label><span class="req">*</span> Association Type</label>
        <div class="select-wrap">
            <ng-select (change)="onChangecomponentType($event)" appendTo="body"  placeholder="Select " class="field-input filled">
                <ng-option value="TRUCK">Truck</ng-option>
                <ng-option value="TRAILER">Trailer</ng-option>
            </ng-select>
        </div>
      </div>
      <div class="form-group">
        <label><span class="req">*</span> Serial Number</label>

        <ng-select appendTo="body" (change)="onserialChange($event)" [(ngModel)]="serialNumber"  placeholder="Select " class="field-input filled">
            <ng-option *ngFor="let item of componantList" [value]="item.id">{{item.serialNumber}}</ng-option>
        </ng-select>
<!--         
        <select>
          <option selected>SN-9931</option>
          <option>SN-9932</option>
          <option>SN-9933</option>
        </select> -->
        <span class="form-hint">Select from available inventory</span>
      </div>
    </div>

    <!-- Step 2 -->
    <div class="step-label">Step 2 — Auto-Populated Info</div>
    <div class="form-row">
      <div class="form-group">
        <label>Brand</label>
        <input type="text" [value]="selectedComponent?.brandName" readonly>
      </div>
      <div class="form-group">
        <label>Model</label>
        <input type="text" [value]="selectedComponent?.productCode" readonly>
      </div>
      <div class="form-group">
        <label>Mfg. Date</label>
        <input type="text" [value]="selectedComponent?.mfgDate  | CustomDatePipe: 'D-M-YYYY'" readonly>
      </div>
    </div>

    <!-- Step 3 -->
    <div class="step-label">Step 3 — Association Details</div>
    <div class="form-row">
      <div class="form-group">
        <label><span class="req">*</span> From Date</label>
        <div class="input-wrap">
          <p-calendar appendTo="body" class="mfgDate" name="date" [(ngModel)]="associationDate" view="date" dateFormat="dd.mm.yy" [maxDate]="maxDate" ></p-calendar>

          <!-- <input type="text" placeholder="DD / MM / YYYY" [value]="selectedComponent?.purchaseDate"> -->
          <span class="input-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
            </svg>
          </span>
        </div>
        <span class="form-hint">Date component is fitted to truck</span>
      </div>
      <div class="form-group">
        <label><span class="req">*</span> KM at Association </label>
        <div class="km-wrap">
          <input class="form-input" id="kmAtRemoval" type="text" [(ngModel)]="associationkm" placeholder="e.g. 2032" oninput="updateSummary()"/>
          <span class="km-unit">km</span>
        </div>
        <span class="form-hint">Current odometer reading</span>
      </div>

      <!-- <div class="form-group">
        <label><span class="req">*</span> Association Status</label>
        <div class="select-wrap">
            <ng-select appendTo="body" [(ngModel)]="associationStatus"  placeholder="Select " class="field-input filled">
                <ng-option value="NEW">New</ng-option>
                <ng-option value="SPARE">Spare</ng-option>
                <ng-option value="IN-USE">In Use</ng-option>
            </ng-select>
        </div>
      </div> -->
    </div>

    <!-- Summary -->
    <div class="summary">
      <div class="summary-title">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>
        </svg>
        Summary
      </div>
      <div class="summary-rows">
        <div class="summary-row">
          <span class="key">Truck</span>
          <span class="val">{{truckDetails?.truckNumber}}</span>
        </div>
        <div class="summary-row">
          <span class="key">Component</span>
          <span class="val">
            <div class="component-tag">
              <div class="component-dot"></div> {{selectedComponent?.componentType}} · {{selectedComponent?.serialNumber}}
            </div>
          </span>
        </div>
        <div class="summary-row">
          <span class="key">From Date</span>
          <span class="val dash">{{associationDate  | CustomDatePipe: 'D-M-YYYY'}} </span>
        </div>
        <div class="summary-row">
          <span class="key">KM at Association</span>
          <span class="val dash">{{associationkm}} km</span>
        </div>
        <!-- <div class="summary-row">
          <span class="key">Running Status</span>
          <span class="val live-val"><div class="live-dot"></div> {{selectedComponent?.status}}</span>
        </div> -->
      </div>
    </div>

  </div>

  <!-- Footer -->
  <div class="modal-footer">
    <span class="footer-note">Running Status will be set to Live automatically</span>
    <div class="footer-actions">
      <button class="btn btn-cancel" (click)="close()">Cancel</button>
      <button class="btn btn-primary" (click)="addComponent()" [disabled]="!associationDate || !associationkm || !selectedComponent">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
        Add Component
      </button>
    </div>
  </div>

</div>